<template>
  <div class="view">

      <header class="top">
        <h2 class="color-tint pointer-hover" @click="addSession">+ Tilføj session</h2>
        <p class="to-bottom" @click="scrollToBottom">Gå til bund</p>
      </header>

      <template v-if="sessions">
        <div class="column" v-el:sessions>
          <div class="inner">
            <template v-if="sessions.length === 0">
              <h3>Ingen aktive sessions</h3>
            </template>
            <ul class="list" v-if="sessions.length > 0 && allExercises.length > 0">
              <li v-for="session in sessions" class="list-item">
                <header>
                  <h3>Session {{$index + 1}}</h3>
                  <span @click="deleteSession($index)">Fjern</span>
                </header>

                <ul class="horisontal" v-sortable="sortableOptions" :data-session="$index">
                  <li
                    v-for="exercise in session.exercises"
                    :class="exercise.status"
                    :data-session="$parent.$index"
                    :data-id="exercise.id" 
                    :data-sub-id="exercise.subId">
                      <span class="status" :class="exercise.status" @click="toggleStatus(exercise)"></span>
                      <span v-link="{name: 'subexercise', params: {id: exercise.id, subid: parseInt(exercise.subId)}}">{{getExercise(exercise.id).title}}</span>
                      <span class="index">{{parseInt(exercise.subId) + 1 }}</span>
                      <span class="index" @click="removeExercise($index, $parent.$index)">x</span>
                  </li>
                </ul>

              </li>
            </ul>
          </div>
        </div>
        <div class="column column-exercises" v-if="allExercises">
          <div class="inner">
            <h2>Øvelser</h2>
            <filters :filters="filters" @filter="setFilter"></filters>
            <ul class="list">
              <li class="list-item" v-for="exercise in filteredExercises">
                <h3 v-link="{name: 'exercise', params: {id: exercise.id}}">{{exercise.title}}</h3>
                <ul class="horisontal" v-sortable="sortableExercisesOptions">
                  <li class="outline" v-for="subexercise in exercise.exercises" :data-id="exercise.id" :data-sub-id="subexercise.id" data-remove="true">
                    {{$index + 1}}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </template>
  </div>
</template>

<script>
import view from '../mixins/view'
import exercises from '../mixins/exercises'
import { Sessions } from 'api/resources'
import HeaderGroup from 'components/HeaderGroup'
import Filters from 'components/Filters'

export default {
  name: 'SessionsView',
  mixins: [view, exercises],
  components: {
    HeaderGroup, Filters
  },
  data () {
    return {
      sortableOptions: {
        animation: 150,
        delay: 150,
        group: 'sessions',
        scroll: false,
        scrollSpeed: 0,
        onAdd: (e) => {
          console.log('%conAdd', 'font-weight: bold', e)
          const sessionIndex = e.to.dataset.session
          const newExerciseIndex = e.newIndex
          const exercises = this.sessions[sessionIndex].exercises

          const appendExercise = {
            id: e.item.dataset.id,
            status: 'pending',
            subId: e.item.dataset.subId,
            test: e.item.innerHTML
          }
          exercises.splice(newExerciseIndex, 0, appendExercise)

          // Remove sortable dom element
          if (e.item.dataset.remove) {
            e.item.parentNode.removeChild(e.item)
          }
          // Save to server
          this.save()
        },
        onRemove: (e) => {
          console.log('%conRemove', 'font-weight: bold', e)
          this.sessions[e.item.dataset.session].exercises.splice(e.oldIndex, 1)
          this.save()
        },
        onUpdate: (e) => {
          console.log('%conUpdate', 'font-weight: bold')
          const arr = this.sessions[e.item.dataset.session].exercises
          const element = arr[e.oldIndex]
          arr.splice(e.oldIndex, 1)
          arr.splice(e.newIndex, 0, element)
          this.save()
        }
      },
      sortableExercisesOptions: {
        animation: 150,
        delay: 150,
        group: {
          name: 'sessions',
          pull: 'clone',
          put: false
        },
        sort: false
      }
    }
  },
  computed: {
    id () {
      return this.$route.params.team
    }
  },
  asyncComputed: {
    sessions () {
      return Sessions.get({id: this.id})
      .then(response => response.data)
    }
  },
  methods: {
    setFilter (filter) {
      this.filter = filter
    },
    scrollToBottom () {
      this.$els.sessions.scrollTop = this.$els.sessions.scrollHeight
    },
    getExercise (id) {
      return this.allExercises.find(exercise => exercise.id === parseInt(id))
    },
    addSession () {
      this.sessions.push({
        exercises: []
      })
    },
    deleteSession (index) {
      if (window.confirm('Sikker på du vil slette hele sessionen?')) {
        this.sessions.splice(index, 1)
        this.save()
      }
    },
    removeExercise (index, session) {
      if (window.confirm('Sikker på du vil slette øvelsen?')) {
        this.sessions[session].exercises.splice(index, 1)
        this.save()
      }
    },
    save () {
      console.log('%csave in progress', 'font-weight: bold; color: grey')
      Sessions.update({id: this.id}, JSON.stringify(this.sessions))
      .then(response => {
        console.log('%csaved', 'font-weight: bold; color: green', response)
      })
    },
    toggleStatus (exercise) {
      exercise.status = exercise.status === 'done' ? 'pending' : 'done'
      this.save()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/boilerplate';

.container {
  width: 100%;
  max-width: 100%;
  margin-left: -$grid-gutter-width / 2;
  margin-right: -$grid-gutter-width / 2;
}
header.top {
  width: 50%;
  left: 0;
  position: absolute;
  z-index: 10;
  background: white;
  height: 7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 $grid-gutter-width;

  h2 {
    margin-bottom: 0;
  }
}

.column {
  position: absolute;
  width: 50%;
  top: 7rem + 7rem;
  left: 0;
  bottom: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;

  &-exercises {
    background: $color-orange;
    color: white;
    top: 0rem;
    left: auto;
    right: 0;

    .inner {
      padding: $grid-gutter-width;
    }
  }
}
.to-bottom {
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 0;
  &:hover {
    opacity: 0.5;
  }
}

.inner {
  position: absolute; 
  top: 0px; 
  left: 0px;
  width: 100%;
  padding-right: $grid-gutter-width;
  padding-left: $grid-gutter-width;
}

.row {
  outline: 2px solid red;
}

button {
  background: #eee;
  color: white;
}

h2 {
  margin-bottom: 3rem;
}

.status {
  border: 2px solid;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  display: inline-block;
  margin-right: 1rem;

  &.done {
    background: currentcolor;
  }
}
.index {
  display: inline-block;
  margin-left: .5rem;
}
.list {
  .list-item {
    flex: 1;
    padding: 1rem 0;
    position: relative;
  
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: currentcolor;
      opacity: 0.25;
      bottom: 0;
      left: 0;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
  ul.horisontal {
    display: flex;
    flex-wrap: wrap;

    li {
      background: black;
      color: white;
      margin-right: 1rem;
      margin-bottom: 1rem;
      // box-shadow: rgba(black, .2) 0px 2px 20px;
      // border-radius: 4px;
      position: relative;
      // font-size: 0.75rem;
      font-weight: bold;
      display: flex;
      align-items: center;

      &.done {
        opacity: .25;
        background: lightgrey;
        color: black;
      }

      &.outline {
        box-shadow: none;
        background: none;
        border: 2px solid;
        color: currentcolor;
      }
    }
  }
}
ul {
  min-height: 11px;
  margin: 0px;
  padding: 0px;
  list-style: none;

  li {
    cursor: pointer;
    // padding: 1rem;

    &.sortable-chosen {
      background: blue;
      color: white;
      box-shadow: rgba(black, .4) 0px 3px 25px;
    }

    &.active {
      opacity: 0.5;
    }

    ul {
      //margin-left: 4rem;

      li {
        padding: 1rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Sessions.vue?2c906dbb